"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractServiceFacade = _interopRequireDefault(require("../AbstractServiceFacade"));

var _LocalizationServiceFacade = _interopRequireDefault(require("./LocalizationServiceFacade"));

var _ArticleServiceFacade = _interopRequireDefault(require("./ArticleServiceFacade"));

var _TotalPriceCalculator = _interopRequireDefault(require("../util/TotalPriceCalculator"));

var _ServiceFacadeException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceFacadeException"));

var _Console = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/Console"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * This class is used as a simple interface for handling prices.
 */
var PriceServiceFacade = /*#__PURE__*/function (_AbstractServiceFacad) {
  _inherits(PriceServiceFacade, _AbstractServiceFacad);

  var _super = _createSuper(PriceServiceFacade);

  function PriceServiceFacade() {
    _classCallCheck(this, PriceServiceFacade);

    return _super.apply(this, arguments);
  }

  _createClass(PriceServiceFacade, null, [{
    key: "getTotalPrice",

    /**
     * Calculates total price.
     *
     * @example PriceServiceFacade.getTotalPrice([ { type: 'ART', id: '123456', qty: 2 }, { type: 'ART', id: '654321', qty: 1 } ]).then(totalPrice => {
     * // Handle total price model (TotalPriceModel)
     * }).catch(error => {
     * // Handle error
     * });
     * @param {object[]} items Array of items.
     * @returns {Promise} Promise object.
     */
    value: function getTotalPrice(items) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _LocalizationServiceFacade.default.getData().then(function (local) {
          _ArticleServiceFacade.default.getArticles(items).then(function (articles) {
            try {
              resolve(_TotalPriceCalculator.default.calculate(items, articles, local.localization.dateFormat));
            } catch (error) {
              reject(new _ServiceFacadeException.default('Failed to calculate total price. Error: ' + error.toString(), _this.serviceName));
            }
          }).catch(reject);
        }).catch(reject);
      });
    }
    /**
     * Returns total price for cached items.
     *
     * @example const totalPrice = PriceServiceFacade.getCachedTotalPrice([ { type: 'ART', id: '123456', qty: 2 }, { type: 'ART', id: '654321', qty: 1 } ]);
     * @param {object[]} items Array of items.
     * @returns {object} Total Price.
     */

  }, {
    key: "getCachedTotalPrice",
    value: function getCachedTotalPrice(items) {
      var local = _LocalizationServiceFacade.default.getCacheItem('localization');

      if (local) {
        var articles = _ArticleServiceFacade.default.getCachedArticles(items);

        if (articles && articles.length > 0) {
          var calculatedPrice = null;

          try {
            calculatedPrice = _TotalPriceCalculator.default.calculate(items, articles, local.localization.dateFormat);
          } catch (error) {
            _Console.default.warn(error);
          }

          return calculatedPrice;
        }
      }

      return null;
    }
    /**
     * Returns the service name.
     *
     * @override
     * @returns {string} Service name.
     */

  }, {
    key: "serviceName",
    get: function get() {
      return 'PriceServiceFacade';
    }
  }]);

  return PriceServiceFacade;
}(_AbstractServiceFacade.default);

exports.default = PriceServiceFacade;